export const validatePhoneNumber = value => {
  // add + to beginning, remove all non-digits, and limit to 14 digits
  const validPhone = '+' + value?.replace(/\D/g, '')?.slice(0, 14)
  // regex for phone number of pattern +########## with length of 11 to 14
  const regex = /^\+{0,1}?[0-9]{11,14}$/
  const isPhoneValid = regex.test(validPhone)
  return { isPhoneValid, validPhone }
}
